import TableComponent from '../../Common/Charts/TableCharts';
import { number } from '../../Common/Util/number';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';
import { useSanitizeData } from '../Common/hooks/useSanitizeData';
import '../Common/Styles/Ciha.css';

export const TopDiagnosisTable = () => {
    const { chartData } = useEpidemiologyChartsDataContext();

    const tableColumns = [
        {
            key: 'cid',
            header: 'CID',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' },
            formatter: (value) => (
                <span className="table-badge">
                    {value}
                </span>
            )
        },
        {
            key: 'nome',
            header: 'Nome',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' }
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: {
                fontWeight: '700',
                textAlign: 'right'
            },
            cellStyle: {
                textAlign: 'right',
                fontWeight: '400'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'pct',
            header: '%',
            headerStyle: {
                fontWeight: '700',
                textAlign: 'right'
            },
            cellStyle: {
                textAlign: 'right',
                fontWeight: '400'
            },
            formatter: (value) =>
                `${number.formatToBRNumber(value)}%`
        }
    ];

    const rawData = chartData?.epidemiologyTopDiagnosis || [];

    const sanitizedData = useSanitizeData(rawData);

    return (
        <TableComponent
            className="no-spacing-table"
            data={sanitizedData}
            columns={tableColumns}
            title="Diagnósticos mais frequentes"
            formatNumber={number.formatToBRNumber}
        />
    );
};